module.exports = __webpack_public_path__ + "img/main-number1.76bdb7ba.png";